<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : task.pkId ? '编辑' : '新建'"
      width="1000px"
      class="adaptationModal"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="task"
        :rules="ruleValidate"
        class="form"
        label-width="110px">
      <div class="editTitle">任务信息</div>
      <el-row>
        <el-col v-if="task.pkId" :span="12">
          <el-form-item label="任务编号">
            <el-input v-model="task.taskNo" placeholder="请输入任务编号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属项目" prop="projectName">
            <el-input v-model="task.projectName" placeholder="请选择所属项目" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.projectSelect.open()"/>
            </el-input>
            <project-select ref="projectSelect" @select="onSelectProject"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务名称" prop="taskName">
            <el-input v-model="task.taskName" placeholder="请输入任务名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="审核人" prop="approveName">
            <el-input v-model="task.approveName" placeholder="请选择审批人" readonly>
              <el-button slot="append" @click="$refs.selectApproveMember.open()">选择</el-button>
            </el-input>
          </el-form-item>
          <selectMember ref="selectApproveMember" @select="onSelectApprove"/>
        </el-col>
        <el-col :span="12">
          <el-form-item label="优先级" prop="priority">
            <el-select v-model="task.priority" placeholder="请选择任务优先级">
              <el-option label="低" :value="10"/>
              <el-option label="中" :value="20"/>
              <el-option label="高" :value="30"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划开始日期" prop="planBeginDate">
            <el-date-picker
                v-model="task.planBeginDate"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                type="date"
                placeholder="请选择计划开始日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划完成日期" prop="planEndDate">
            <el-date-picker
                v-model="task.planEndDate"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                type="date"
                placeholder="请选择计划完成日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务描述">
            <el-input v-model="task.taskDesc" type="textarea" autosize placeholder="请输入任务描述"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">任务成员</div>
      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.selectMember.open()"> 添加</el-button>
      <Table border :columns="memberColumns" :data="task.memberList">
        <template slot="action" slot-scope="{ index }">
          <el-button type="danger" @click="task.memberList.splice(index, 1)">删除</el-button>
        </template>
      </Table>
      <selectMember ref="selectMember" @select="onSelectMember"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import selectMember from "@/views/SystemInfo/SystemUser/UserSelect";
  import ProjectSelect from "../ProjectManagement/ProjectSelect.vue";

  export default {
    components: {selectMember, ProjectSelect},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled: "",
        task: {
          pkId: 0,
          taskName: "",
          projectId: "",
          projectName: "",
          planBeginDate: "",
          planEndDate: "",
          priority: "",
          taskDesc: "",
          approveName: "",
          approveId: 0,
          memberList: [],
        },
        ruleValidate: {
          taskName: {required: true, message: "请输入任务名称", trigger: "blur"},
          priority: {required: true, message: "请选择任务优先级", trigger: "change"},
          projectName: {required: true, message: "请选择所属项目", trigger: "change"},
          planBeginDate: {required: true, message: "请选择计划开始日期", trigger: "change"},
          planEndDate: {required: true, message: "请选择计划完成日期", trigger: "change"},
          approveName: {required: true, message: "请选择审核人", trigger: "change"},
        },
        memberColumns: [
          {
            title: "姓名",
            key: "memberName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },

    methods: {
      open(row, mark) {
        this.disabled = !!mark;

        if (row != null && row.status !== 10) {
          this.disabled = true;
        }


        this.dialogVisible = true;
        if (row) {
          this.getData(row.pkId);
        }
      },

      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `tasks/${pkId}`)
          .then((resp) => {
            this.contentLoading = false;
            if (resp.success) {
              this.task = Object.assign(this.task, resp.data);
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 选择项目
      onSelectProject(row) {
        this.task.projectId = row.pkId;
        this.task.projectName = row.projectName;
      },

      //选择审核人
      onSelectApprove(row) {
        this.task.approveId = row.systemUserID;
        this.task.approveName = row.employeeName;
      },
      onSelectMember(row) {
        const arr = this.task.memberList.filter((item) => item.memberId === row.systemUserID);
        if (arr.length) {
          this.$confirm(`${row.employeeName}已存在,请勿重复添加`, "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const member = {
          memberId: row.systemUserID,
          memberName: row.employeeName,
        };
        this.task.memberList.push(member);
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.task.memberList.length) {
              this.$confirm("请选择任务成员", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else {
              this.submitLoading = true;
              this.task.memberList.forEach((item, index) => {
                item.rowIndex = index + 1;
              });
              this.$http
                .save("basic", "tasks", this.task)
                .then((resp) => {
                  this.submitLoading = false;
                  if (resp.success) {
                    if (this.task.pkId) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                    } else {
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                    }
                    this.dialogVisible = false;
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },

      deleteMember(row, index) {
        if (row.statusName) {
          this.$confirm(`当前成员任务进度为:${row.statusName},确认删除吗?`, "提示", {type: "warning"}).then(() => {
            this.task.memberList.splice(index, 1);
          });
        } else {
          this.task.memberList.splice(index, 1);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>
